import React, { useContext, useEffect } from "react";
import { AuthContext } from "../components/AuthContext";
import { UserContext } from "../components/UserContext";
import { DashboardProvider } from "../components/dashboard-page/DashboardContext";
import Sidebar from "../components/dashboard-page/Sidebar";
import { Routes, Route, useNavigate } from "react-router-dom";
import Settings from "../components/dashboard-page/Settings";
import MyTeam from "../components/dashboard-page/MyTeam";
import Profile from "../components/dashboard-page/Profile";
import MainPage from "../components/dashboard-page/MainPage";
import LoadingCircle from "../components/LoadingCircle";
import Matches from "../components/dashboard-page/Matches";
import { PlatformContext } from "../components/Platform/PlatformContext";
import ManageSeason from "../components/dashboard-page/ManageSeason";
import Refereeing from "../components/dashboard-page/Refereeing";

const Dashboard: React.FC = () => {
  const { isAuthenticated, isLoading: authLoading } = useContext(AuthContext);
  const { user, isLoading: userLoading } = useContext(UserContext);
  const context = useContext(PlatformContext);
  const isMobile = !context?.isDesktop;

  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate("/login");
    }
  }, [authLoading, isAuthenticated, navigate]);

  if (authLoading || userLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <LoadingCircle />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <DashboardProvider>
      <>
        <div className="w-full h-screen overflow-y-auto flex">
          {!isMobile && <Sidebar />}
          <Routes>
            <Route path="/seasons" element={<ManageSeason />} />
            <Route path="/" element={<MainPage />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
            <Route path="my-team" element={<MyTeam />} />
            <Route path="matches" element={<Matches />} />
            <Route path="*" element={<MainPage />} />
            <Route path="refereeing" element={<Refereeing />} />
          </Routes>
        </div>
      </>
    </DashboardProvider>
  );
};

export default Dashboard;
